import qs from '../../utilities/query-string';
import React, { Component } from 'react';
import FullReportComponent from "./full-report-charts-component";
import {connect} from "react-redux";
import { withRouter } from 'react-router-dom';
import {
  loadPrimaryEmotionsBreakdownRequest, loadSentimentBreakdownRequest,
  loadTopWordsRequest
} from "../charts/charts-action-creators";
import {changeReportUrl} from "../report/report-action-creators";


class FullReportContainer extends Component {

  constructor(props) {
    super(props);
    const reportUrl = qs.parse(this.props.location.search).reportUrl;
    this.props.changeReportUrl(reportUrl);
  }

  componentDidMount() {
    const {
      topWords,
      sentimentBreakdown,
      primaryEmotionsBreakdown,
      loadTopWords,
      loadSentimentBreakdown,
      loadPrimaryEmotionsBreakdown
    } = this.props;
    !topWords.length ? loadTopWords() : null;
    !sentimentBreakdown.length ? loadSentimentBreakdown() : null;
    !primaryEmotionsBreakdown.length ? loadPrimaryEmotionsBreakdown() : null;
  }

  render() {
    return <FullReportComponent {...this.props} />
  }
}


const mapStateToProps = state => ({
  topWords: state.charts.topWords,
  topWordsLoading: state.charts.topWordsLoading,
  sentimentBreakdown: state.charts.sentimentBreakdown,
  sentimentBreakdownLoading: state.charts.sentimentBreakdownLoading,
  primaryEmotionsBreakdown: state.charts.primaryEmotionsBreakdown,
  primaryEmotionsBreakdownLoading: state.charts.primaryEmotionsBreakdownLoading
});

const mapDispatchToProps = dispatch => ({
  loadTopWords: () => dispatch(loadTopWordsRequest()),
  loadSentimentBreakdown: () => dispatch(loadSentimentBreakdownRequest()),
  loadPrimaryEmotionsBreakdown: () => dispatch(loadPrimaryEmotionsBreakdownRequest()),
  changeReportUrl: reportUrl => dispatch(changeReportUrl(reportUrl))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FullReportContainer))


// WEBPACK FOOTER //
// ./src/modules/full-report-charts/full-report-charts-container.js